import { Gallery } from '@/components/app/product/components/gallery';

export const DATA_CY_HERO = 'data-cy-hero';
export const DATA_CY_STORY = 'data-cy-story';
export const DATA_CY_STORY_SLIDER = 'data-cy-story-slider';
export const DATA_CY_ADDS_BANNER = 'data-cy-adds-banner';
export const DATA_CY_BUNDLES = 'data-cy-bundles';
export const DATA_CY_PRODUCTS = 'data-cy-products';
export const DATA_CY_PRODUCT_BANNER = 'data-cy-product-banner';
export const DATA_CY_DEMOS = 'data-cy-demos';
export const DATA_CY_DEMO = 'data-cy-demo';
export const DATA_CY_BEST_SELLER = 'data-cy-best-seller';
export const DATA_CY_BEST_PRODUCTS = 'data-cy-best-products';
export const DATA_CY_BLOGS = 'data-cy-blogs';
export const DATA_CY_COURSES = 'data-cy-courses';
export const DATA_CY_COURSE = 'data-cy-course';
export const DATA_CY_BUNDLES_SLIDER = 'data-cy-bundles-slider';
export const DATA_CY_BLOGS_SLIDER = 'data-cy-blogs-slider';
export const DATA_CY_BEST_SELLER_PRODUCTS = 'data-cy-best-seller-products';
export const DATTA_CY_MENU_BUTTON = 'data-cy-menu-button';
export const DATTA_CY_MOBILE_MENU_BUTTON = 'data-cy-mobile-menu-button';
export const DATTA_CY_MENU_ITEM_BUTTON = 'data-cy-menu-item-button';
export const DATA_CY_MENU_CLOSE_BUTTON = 'data-cy-menu-close-button';
export const DATA_CY_SEARCH_INPUT = 'data-cy-search-input';
export const DATA_CY_SEARCH_POP_UP_INPUT = 'data-cy-search-pop-up-input';
export const DATA_CY_SEARCH_POP_UP = 'data-cy-search-pop-up';
export const DATA_CY_SEARCH_RESULT_PRODUCTS = 'data-cy-search-result-products';
export const DATA_CY_SEARCH_RESULT_THEME_DEMOS = 'data-cy-search-result-theme-demos';
export const DATA_CY_SEARCH_No_RESULT = 'data-cy-search-no-result';
export const DATA_CY_SEARCH_SUGGESTS = 'data-cy-search-suggests';
export const DATA_CY_HEADER = 'data-cy-header';
export const DATA_CY_MOBILE_HEADER = 'data-cy-mobile-header';
export const DATA_CY_ADD_TO_CARD_BUTTON = 'data-cy-add-to-card-button';
export const DATA_CY_PREVIEW_BUTTON = 'data-cy-preview-button';
export const DATA_CY_PRODUCT_CARD = 'data-cy-product-card';
export const DATA_CY_PRODUCT_CARD_ICONIC = 'data-cy-product-card-iconic';
export const DATA_CY_PRODUCT_CARD_ICONIC_MOBILE = 'data-cy-product-card-iconic-mobile';
export const DATA_CY_PRODUCT_CONTENT_CARD = 'data-cy-product-content-card';
export const DATA_CY_PRODUCT_LIST_CARD = 'data-cy-product-list-card';
export const DATA_CY_MENU_CONTAINER = 'data-cy-menu-container';
export const DATA_CY_FOOTER_ACHIEVEMENTS = 'data-cy-footer-achievements';
export const DATA_CY_FOOTER_SOCIAL_MEDIA = 'data-cy-footer-social_media';
export const DATA_CY_FOOTER_MENU = 'data-cy-footer-menu';
export const DATA_CY_FOOTER_ABOUT_US = 'data-cy-footer-about-us';
export const DATA_CY_FOOTER_POLICY = 'data-cy-footer-policy';
export const DATA_CY_FOOTER_NEWSLETTER = 'data-cy-footer-newsletter';
export const DATA_CY_FOOTER_CONTACT = 'data-cy-footer-contact';
export const DATA_CY_FOOTER_SUB_MENU = 'data-cy-footer-sub-menu';
export const DATA_CY_FOOTER_MENU_BUTTON = 'data-cy-footer-menu-button';
export const DATA_CY_INFO = 'data-cy-info';
export const DATA_CY_FILTER_IN_MOBILE = 'data-cy-filter-in-mobile';
export const DATA_CY_FILTER_IN_DESKTOP = 'data-cy-filter-in-desktop';
export const DATA_CY_SORT_CONTAINER = 'data-cy-sort-container';
export const DATA_CY_ICON_TEXT_COMBO = 'data-cy-icon-text-combo';
export const DATA_CY_ARCHIVE_SORT_ITEM_CONTAINER = 'data-cy-archive-sort-item-container';
export const DATA_CY_ARCHIVE_SORT_ITEM = 'data-cy-archive-sort-item';
export const DATA_CY_ARCHIVE_FAQ = 'data-cy-archive-faq';
export const DATA_CY_ARCHIVE_DESCRIPTION = 'data-cy-archive-description';
export const DATA_CY_BREAD_CRUMB = 'data-cy-bread-crumb';
export const DATA_CY_VIEW_MODE_GRID = 'data-cy-view-mode-grid';
export const DATA_CY_VIEW_MODE_LIST = 'data-cy-view-mode-list';
export const DATA_CY_FILTER_POP_UP = 'data-cy-filter-pop-up';
export const DATA_CY_SHOW_MORE_BUTTON = 'data-cy-show-more-button';
export const DATA_CY_FAQ_ACCORDION_BUTTON = 'data-cy-faq-accordion-button';
export const DATA_CY_FAQ_ACCORDION_PANEL = 'data-cy-faq-accordion-panel';
export const DATA_CY_LOADING = 'data-cy-loading';
export const DATA_CY_CHECK_BOX_ITEM = 'data-cy-check-box-item';
export const DATA_CY_VIEW_SELECTOR = 'data-cy-view-selector';
export const DATA_CY_STYLISH_ACCORDION_BUTTON = 'data-cy-stylish-accordion-button';
export const DATA_CY_STYLISH_ACCORDION_BUTTON_MINUS_ICON =
  'data-cy-stylish-accordion-button-minus_icon';
export const DATA_CY_STYLISH_ACCORDION_BUTTON_PLUS_ICON =
  'data-cy-stylish-accordion-button-minus-icon';
export const DATA_CY_STYLISH_ACCORDION_PANEL = 'data-cy-stylish-accordion-panel';
export const DATA_CY_PRODUCT_CART = 'data-cy-product-cart';
export const DATA_CY_PRODUCT_CART_MOBILE = 'data-cy-product-cart-mobile';
export const DATA_CY_PRODUCT_DEMO_CONTAINER = 'data-cy-product-demo-container';
export const DATA_CY_PRODUCT_DESCRIBE = 'data-cy-product-describe';
export const DATA_CY_PRODUCT_COMMENTS = 'data-cy-product-comments';
export const DATA_CY_PRODUCT_COMMENT_Box = 'data-cy-product-comment-box';
export const DATA_CY_PRODUCT_SUPPORT = 'data-cy-product-support';
export const DATA_CY_PRODUCT_DESCRIBE_TAB = 'data-cy-product-describe-tab';
export const DATA_CY_PRODUCT_COMMENTS_TAB = 'data-cy-product-comments-tab';
export const DATA_CY_PRODUCT_SUPPORT_TAB = 'data-cy-product-support-tab';
export const DATA_CY_PRODUCT_SIDEBAR_CART = 'data-cy-product-sidebar-cart';
export const DATA_CY_RELATED_PRODUCTS = 'data-cy-related-products';
export const DATA_CY_VENDOR_PRODUCTS = 'data-cy-vendor-products';
export const DATA_CY_PRODUCT_TAGS = 'data-cy-product-tags-container';
export const DATA_CY_PRODUCT_TAG_NAME = 'data-cy-product-tag-name';
export const DATA_CY_HIGHLIGHTS_PRODUCTS_MOBILE = 'data-cy-highlights-products-mobile';
export const DATA_CY_AFFILIATE_CARD_PRODUCTS_MOBILE = 'data-cy-affiliate-card-products-mobile';
export const DATA_CY_AFFILIATE_CARD_MORE_INFO = 'data-cy-affiliate-card-more-info';
export const DATA_CY_AFFILIATE_CARD_GET_LINK = 'data-cy-affiliate-card-get-link';
export const DATA_CY_AFFILIATE_CARD_START_AFFILIATE = 'data-cy-affiliate-card-start-affiliate';
export const DATA_CY_AFFILIATE_CARD_PRODUCT_TITLE = 'data-cy-affiliate-card-product-title';
export const DATA_CY_AFFILIATE_CARD_PRODUCTS = 'data-cy-affiliate-card-products';
export const DATA_CY_STORE_CARD_PRODUCTS = 'data-cy-store-card-products';
export const DATA_CY_SHOW_MORE = 'data-cy-show-more';
export const DATA_CY_PRODUCT_DETAILS = 'data-cy-product-details';
export const DATA_CY_ADD_COMMENT_BUTTON = 'data-cy-add-comment-button';
export const DATA_CY_ADD_COMMENT_BOX = 'data-cy-add-comment-box';
export const DATA_CY_ADD_COMMENT_TEXTAREA = 'data-cy-add-comment-textarea';
export const DATA_CY_SHOW_COMMENT_TEXTAREA = 'data-cy-show-comment-textarea';
export const DATA_CY_SEND_COMMENT = 'data-cy-send-comment';
export const DATA_CY_CLOSE_COMMENT_BOX = 'data-cy-close-comment-box';
export const DATA_CY_SIGN_IN_BUTTON = 'data-cy-sign-in-button';
export const DATA_CY_ADD_TO_CARD_POP_UP = 'data-cy-add-to-card-pop-up';
export const DATA_CY_ADD_TO_CARD_POP_UP_HEAD = 'data-cy-add-to-card-pop-up-head';
export const DATA_CY_RETURN_BUTTON = 'data-cy-return-button';
export const DATA_CY_CHANGE_LOG = 'data-cy-change-log';
export const DATA_CY_COMMENTS_SUMMARY = 'data-cy-comments-summary';
export const DATA_CY_PRODUCT_FAQ = 'data-cy-product-faq';
export const DATA_CY_PRODUCT_BUNDLE_CARD = 'data-cy-product-bundle-card';
export const DATA_CY_ITEM_PRICE = 'data-cy-item-price';
export const DATA_CY_OPTIONS_ITEM = 'data-cy-options-item';
export const DATA_CY_OPTIONS_ITEM_CONTAINER = 'data-cy-options-item-container';
export const DATA_CY_LAST_PRICE_CONTAINER = 'data-cy-last-price-container';
export const DATA_CY_ABOUT_HISTORY = 'data-cy-about-history';
export const DATA_CY_ABOUT_BENEFITS = 'data-cy-about-benefits';
export const DATA_CY_ABOUT_BENEFIT_CARD = 'data-cy-about-benefit-card';
export const DATA_CY_ABOUT_EXTRA_PRODUCTS = 'data-cy-about-extra-products';
export const DATA_CY_ABOUT_EXTRA_PRODUCT = 'data-cy-about-extra-product';
export const DATA_CY_ABOUT_ACHIEVEMENTS = 'data-cy-about-achievements';
export const DATA_CY_ABOUT_COMPANIES = 'data-cy-about-companies';
export const DATA_CY_CONTACT_US_CARD = 'data-cy-contact-us-card';
export const DATA_CY_CONTACT_US_INP_NAME = 'data-cy-contact-us-inp-name';
export const DATA_CY_CONTACT_US_INP_RELEVANT_UNIT = 'data-cy-contact-us-inp-relevant-unit';
export const DATA_CY_CONTACT_US_INP_MESSAGE = 'data-cy-contact-us-inp-message';
export const DATA_CY_CONTACT_INFO_CARD = 'data-cy-contact-info-card';
export const DATA_CY_LOGIN_BUTTON = 'data-cy-login-button';
export const DATA_CY_LOGIN = 'data-cy-login';
export const DATA_CY_PRODUCTS_TAB = 'data-cy-productS-tab';
export const DATA_CY_INTRODUCTION_TAB = 'data-cy-introduction-tab';
export const DATA_CY_STORE_INTRO_CARD = 'data-cy-store-intro-card';
export const DATA_CY_STORE_MEDAL_CARD = 'data-cy-store-medal-card';
export const DATA_CY_MEDAL_ICON = 'data-cy-medal-icon';
export const DATA_CY_MEDAL_TEXT = 'data-cy-medal-text';
export const DATA_CY_TOOLTIP = 'data-cy-tooltip';
export const DATA_CY_PAGE_NUMBER_NEXT = 'data-cy-page-number-next';
export const DATA_CY_PRODUCT_TITLE = 'data-cy-product-title';
export const DATA_CY_PRODUCT_NAME = 'data-cy-product-name';
export const DATA_CY_MESSAGE = 'data-cy-message';
export const DATA_CY_DEMO_NAME = 'data-cy-demo-name';
export const DATA_CY_BEST_SELLER_NAME = 'data-cy-best-seller-name';
export const DATA_CY_SPOTLIGHT_CARD = 'data-cy-spotlight-card';
export const DATA_CY_SPOTLIGHT_BUTTON = 'data-cy-spotlight-button';
export const DATA_CY_CART_NUMBER = 'data-cy-cart-number';
export const DATA_CY_MENU_ITEM_PARENT = 'data-cy-menu-item-parent';
export const DATA_CY_FOOTER_LINK = 'data-cy-footer-link';
export const DATA_CY_REPLY_BUTTON = 'data-cy-reply-button';
export const DATA_CY_LIKE_BUTTON = 'data-cy-like-button';
export const DATA_CY_DISLIKE_BUTTON = 'data-cy-dislike-button';
export const DATA_CY_TOAST = 'data-cy-toast';
export const DATA_CY_CASCADING_MENU_BUTTON = 'data-cy-cascading-menu-button';
export const DATA_CY_CASCADING_MENU_ITEM_BUTTON = 'data-cy-cascading-menu-item-button';
export const DATA_CY_SIDEIN = 'data-cy-sidein';
export const DATA_CY_SIDEIN_LINK = 'data-cy-sidein-link';
export const DATA_CY_SIDEIN_CLOSE_BTN = 'data-cy-sidein-close-btn';
export const DATA_CY_CASCADING_MENU = 'data-cy-cascading-menu';
export const DATA_CY_CASCADING_MENU_ITEM = 'data-cy-cascading-menu-item';
export const DATA_CY_TOPBAR = 'data-cy-topbar';
export const DATA_CY_TOPBAR_LINK = 'data-cy-topbar-link';
export const DATA_CY_TOPBAR_CLOSE = 'data-cy-topbar-close';
export const DATA_CY_ADD_TO_CARD_POP_UP_HEADER = 'data-cy-add-to-card-pop-up-header';
export const DATA_CY_ADD_TO_CARD_POP_UP_FOOTER = 'data-cy-add-to-card-pop-up-footer';
export const DATA_CY_PRODUCT_PRICE = 'data-cy-product-price';
export const DATA_CY_OPTIONS_ITEM_LABEL = 'data-cy-options-item-label';
export const DATA_CY_OPTIONS = 'data-cy-options';
export const DATA_CY_STORE_TABS = 'data-cy-store-tabs';
export const DATA_CY_STORE_DISCOUNT_CARD = 'data-cy-store-discount-card';
export const DATA_CY_STORE_DISCOUNT_TAB = 'data-cy-store-discount-tab';
export const DATA_CY_STORE_DISCOUNT_ITEM = 'data-cy-store-discount-item';
export const DATA_CY_STORE_DISCOUNT_COPY = 'data-cy-store-discount-copy';
export const DATA_CY_CART_BUTTON = 'data-cy-cart-button';
export const DATA_CY_STEPPED_DISCOUNT_SECTION = 'data-cy-stepped-discount-section';
export const DATA_CY_QUANTITY_CONTROLS_SECTION = 'data-cy-quantity-controls-section';
export const DATA_CY_INCREASE_NUMBER_BUTTON = 'data-cy-increase-number-button';
export const DATA_CY_DECREASE_NUMBER_BUTTON = 'data-cy-decrease-number-button';
export const DATA_CY_STEPS = 'data-cy-steps';
export const DATA_CY_STEPPED_DISCOUNT_TOOLTIP = 'data-cy-stepped-discount-tooltip';
export const DATA_CY_STEPPED_DISCOUNT_TOOLTIP_TEXT = 'data-cy-stepped-discount-tooltip-text';
export const DATA_CY_CART_AMOUNT_PAYABLE = 'data-cy-cart-amount-payable';
export const DATA_CY_DEVELOPER_INTRODUCTION = 'data-cy-developer-introduction';
export const DATA_CY_DEVELOPER_NAME = 'data-cy-developer-name';
export const DATA_CY_DEVELOPER_INTRODUCTION_MODAL = 'data-cy-developer-introduction_modal';
export const DATA_CY_DEVELOPER_INTRODUCTION_LOGO = 'data-cy-developer-introduction_logo';
export const DATA_CY_DEVELOPER_INTRODUCTION_LOGO_ANIMATION =
  'data-cy-developer-introduction_logo_animation';
export const DATA_CY_DEVELOPER_INTRODUCTION_LOGO_BORDER =
  'data-cy-developer-introduction_logo_border';
export const DATA_CY_COOKIE_REJECT = 'data-cy-cookie-reject';
export const DATA_CY_COOKIE_ALERT = 'data-cy-cookie-alert';
export const DATA_CY_PRODUCT_QUESTIONS_TAB = 'data-cy-product-question-tab';
export const DATA_CY_ADD_QUESTION_BUTTON = 'data-cy-add-question-button';
export const DATA_CY_PRODUCT_QUESTIONS = 'data-cy-product-questions';
export const DATA_CY_PRODUCT_QUESTIONS_SUMMARY = 'data-cy-product-questions-summary';
export const DATA_CY_PRODUCT_QUESTION_CARD = 'data-cy-product-question-card';
export const DATA_CY_ADD_QUESTION_BOX = 'data-cy-add-question-box';
export const DATA_CY_ADD_QUESTION_BOX_AFTER_LOGIN = 'data-cy-add-question-box-after-login';
export const DATA_CY_ADD_QUESTION_TEXTAREA = 'data-cy-add-question-textarea';
export const DATA_CY_SUBMIT_QUESTION_BUTTON = 'data-cy-submit-question-button';
export const DATA_CY_QUESTIONS_FILTER = 'data-cy-questions-filter';
export const DATA_CY_ALL_QUESTIONS = 'data-cy-all-questions';
export const DATA_CY_BUYER_QUESTIONS = 'data-cy-buyer-questions';
export const DATA_CY_SHARE_BTN = 'data-cy-share-btn';
export const DATA_CY_LIKE_BTN = 'data-cy-like-btn';
export const DATA_CY_DISLIKE_BTN = 'data-cy-dislike-btn';
export const DATA_CY_FAVORITE_BTN = 'data-cy-favorite-btn';
export const DATA_CY_LINKEDIN_ICON = 'data-cy-linkedin-icon';
export const DATA_CY_WHATSAPP_ICON = 'data-cy-whatsapp-icon';
export const DATA_CY_TWITTER_ICON = 'data-cy-twitter-icon';
export const DATA_CY_TELEGRAM_ICON = 'data-cy-telegram-icon';
export const DATA_CY_OTHER_IMAGES = 'data-cy-other-images';
export const DATA_CY_GALLERY = 'data-cy-gallery';
export const DATA_CY_CLOSE_GALLERY = 'data-cy-close-gallery';
export const DATA_CY_PREV_BTN_GALLERY = 'data-cy-prev-btn-gallery';
export const DATA_CY_NEXT_BTN_GALLERY = 'data-cy-next-btn-gallery';
export const DATA_CY_SLIDE_NUMBER_GALLERY = 'data-cy-slide-number-gallery';
export const DATA_CY_IMG_GALLERY = 'data-cy-img-gallery';
